import { takeLatest, put, call } from "redux-saga/effects";
import TokenService from "utils/auth/Token.service";
import YmsNotification from "utils/functions/notification";
import { translate } from "utils/intl/IntlProvider";
import { getError } from "utils/requests/api.errors";
import * as Api from "./user-session-api";
import { Types, Creators } from "./user-session-duck";

const tokenService = new TokenService();

export const getFilterFromStateUserSession = (state) => state.UserSession;

export function* onFetchLocationsAsync() {
  try {
    const resp = yield call(Api.getLocations);
    const locationsList = Array.isArray(resp?.data) ? resp.data : [];
    yield put(Creators.userSessionLocationsList(locationsList));
  } catch (err) {
    console.error(err);
  } finally {
    yield put(Creators.userSessionHideLoading());
  }
}

export function* onUpdateLocationAsync(action) {
  try {
    yield put(Creators.userSessionShowLoading());
    yield call(Api.updateLocation, {
      id: action.location,
    });
    yield tokenService.refreshToken();
    window.location.href = "/private/lobby";
  } catch (err) {
    console.error(err);
    const requestErrorMessage = yield getError(err) ?? translate("could_not_change_location");
    yield YmsNotification({
      type: "error",
      description: requestErrorMessage,
    });
    window.location.reload();
  } finally {
    yield put(Creators.userSessionHideLoading());
  }
}

export default function* UserSessionSagas() {
  yield takeLatest(Types.USER_SESSION_LOCATIONS_ASYNC, onFetchLocationsAsync);
  yield takeLatest(Types.USER_SESSION_UPDATE_LOCATION_ASYNC, onUpdateLocationAsync);
}
